import { apiConstants } from './shared/config';

const authAccess = { roles: ['COSI_00006'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-home" */ `./views/Home.vue`),
        meta: {
            auth: authAccess,
            hideHeaderName: true,
            title: 'home.title',
        }
    },
    {
        path: `/${apiConstants.code}/entities`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-entities" */ './views/entities/EntityBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.entities`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-entities" */ './views/entities/EntityList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00730']},
                    hideHeaderName: true,
                    title: `entities.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.entities.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-entities" */ './views/entities/EntityDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00732']},
                    hideHeaderName: true,
                    title: `entities.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.entities.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-entities" */ './views/entities/EntityDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00731']},
                    hideHeaderName: true,
                    title: `entities.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00730']},
            hideHeaderName: true,
            title: `entities.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/unities`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-unities" */ './views/unities/UnityBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.unities`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-unities" */ './views/unities/UnityList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00027']},
                    hideHeaderName: true,
                    title: `unities.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.unities.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-unities" */ './views/unities/UnityDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00030']},
                    hideHeaderName: true,
                    title: `unities.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.unities.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-unities" */ './views/unities/UnityDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00028']},
                    hideHeaderName: true,
                    title: `unities.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00027']},
            hideHeaderName: true,
            title: `unities.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/priorities`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-priorities" */ './views/priorities/PriorityBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.priorities`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-priorities" */ './views/priorities/PriorityList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00027']},
                    hideHeaderName: true,
                    title: `priorities.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.priorities.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-priorities" */ './views/priorities/PriorityDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00030']},
                    hideHeaderName: true,
                    title: `priorities.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.priorities.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-priorities" */ './views/priorities/PriorityDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00028']},
                    hideHeaderName: true,
                    title: `priorities.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00027']},
            hideHeaderName: true,
            title: `priorities.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/families`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-families" */ './views/families/FamilyBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.families`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-families" */ './views/families/FamilyList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00660']},
                    hideHeaderName: true,
                    title: `families.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.families.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-families" */ './views/families/FamilyDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00662']},
                    hideHeaderName: true,
                    title: `families.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.families.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-families" */ './views/families/FamilyDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00661']},
                    hideHeaderName: true,
                    title: `families.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00660']},
            hideHeaderName: true,
            title: `families.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/kinds`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-kinds" */ './views/kinds/KindBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.kinds`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-kinds" */ './views/kinds/KindList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00670']},
                    hideHeaderName: true,
                    title: `kinds.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.kinds.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-kinds" */ './views/kinds/KindDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00672']},
                    hideHeaderName: true,
                    title: `kinds.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.kinds.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-kinds" */ './views/kinds/KindDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00671']},
                    hideHeaderName: true,
                    title: `kinds.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00670']},
            hideHeaderName: true,
            title: `kinds.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/types`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-types" */ './views/types/TypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-types" */ './views/types/TypeList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00032']},
                    hideHeaderName: true,
                    title: `types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-types" */ './views/types/TypeDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00035']},
                    hideHeaderName: true,
                    title: `types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-types" */ './views/types/TypeDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00033']},
                    hideHeaderName: true,
                    title: `types.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00032']},
            hideHeaderName: true,
            title: `types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/channels`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-channels" */ './views/channels/ChannelBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.channels`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-channels" */ './views/channels/ChannelList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00042']},
                    hideHeaderName: true,
                    title: `channels.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.channels.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-channels" */ './views/channels/ChannelDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00045']},
                    hideHeaderName: true,
                    title: `channels.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.channels.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-channels" */ './views/channels/ChannelDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00043']},
                    hideHeaderName: true,
                    title: `channels.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00042']},
            hideHeaderName: true,
            title: `channels.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/statuses`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-statuses" */ './views/statuses/StatusBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.statuses`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-statuses" */ './views/statuses/StatusList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00057']},
                    hideHeaderName: true,
                    title: `statuses.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.statuses.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-statuses" */ './views/statuses/StatusDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00050']},
                    hideHeaderName: true,
                    title: `statuses.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.statuses.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-statuses" */ './views/statuses/StatusDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00058']},
                    hideHeaderName: true,
                    title: `statuses.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00047']},
            hideHeaderName: true,
            title: `statuses.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/notifications`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-notifications" */ './views/notifications/NotificationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.notifications`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-notifications" */ './views/notifications/NotificationList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00369']},
                    hideHeaderName: true,
                    title: `notifications.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.notifications.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-notifications" */ './views/notifications/NotificationDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00373']},
                    hideHeaderName: true,
                    title: `notifications.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.notifications.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-notifications" */ './views/notifications/NotificationDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00370']},
                    hideHeaderName: true,
                    title: `notifications.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00369']},
            hideHeaderName: true,
            title: `notifications.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-layers" */ './views/layers/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-layers" */ './views/layers/LayerList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00548']},
                    hideHeaderName: true,
                    title: `layers.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-layers" */ './views/layers/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: {...authAccess, roles: ['COSI_00551']},
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-layers" */ './views/layers/LayerDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00549']},
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-layers" */ './views/layers/LayerDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00549']},
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00548']},
            hideHeaderName: true,
            title: `layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/alarms`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-alarms" */ './views/alarms/AlarmTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.alarms`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-alarms" */ './views/alarms/AlarmTypeList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00720']},
                    hideHeaderName: true,
                    title: `alarms.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.alarms.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-alarms" */ './views/alarms/AlarmTypeDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00722']},
                    hideHeaderName: true,
                    title: `alarms.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.alarms.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-alarms" */ './views/alarms/AlarmTypeDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00721']},
                    hideHeaderName: true,
                    title: `alarms.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00720']},
            hideHeaderName: true,
            title: `alarms.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/cps`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-cps" */ './views/cps/CPSBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.cps`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-cps" */ './views/cps/CPSList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00740']},
                    hideHeaderName: true,
                    title: `cps.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.cps.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-cps" */ './views/cps/CPSDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00742']},
                    hideHeaderName: true,
                    title: `cps.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.cps.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-cps" */ './views/cps/CPSDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00741']},
                    hideHeaderName: true,
                    title: `cps.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00740']},
            hideHeaderName: true,
            title: `cps.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/expedients`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-expedients" */ './views/expedients/ExpedientBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.expedients`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-expedients" */ './views/expedients/ExpedientList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00730']},
                    hideHeaderName: true,
                    title: `expedients.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.expedients.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-expedients" */ './views/expedients/ExpedientDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00732']},
                    hideHeaderName: true,
                    title: `expedients.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.expedients.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-expedients" */ './views/expedients/ExpedientDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00731']},
                    hideHeaderName: true,
                    title: `expedients.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00730']},
            hideHeaderName: true,
            title: `expedients.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/airbases`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-airbases" */ './views/airbases/AirBaseBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.airbases`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-airbases" */ './views/airbases/AirBaseList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00730']},
                    hideHeaderName: true,
                    title: `airbases.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.airbases.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-airbases" */ './views/airbases/AirBaseDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00732']},
                    hideHeaderName: true,
                    title: `airbases.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.airbases.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-airbases" */ './views/airbases/AirBaseDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00731']},
                    hideHeaderName: true,
                    title: `airbases.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00730']},
            hideHeaderName: true,
            title: `airbases.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/categorytypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-categorytypes" */ './views/categorytypes/CategoryTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.category_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-categorytypes" */ './views/categorytypes/CategoryTypeList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00745']},
                    hideHeaderName: true,
                    title: `category_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.category_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-categorytypes" */ './views/categorytypes/CategoryTypeDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00747']},
                    hideHeaderName: true,
                    title: `category_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.category_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosigestao-categorytypes" */ './views/categorytypes/CategoryTypeDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00746']},
                    hideHeaderName: true,
                    title: `category_types.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00745']},
            hideHeaderName: true,
            title: `category_types.titles`,
        }
    },
];

export default routes;
